import { render } from "./ProfileTitle.vue?vue&type=template&id=1e7f06fd&scoped=true"
import script from "./ProfileTitle.vue?vue&type=script&lang=js"
export * from "./ProfileTitle.vue?vue&type=script&lang=js"

import "./ProfileTitle.vue?vue&type=style&index=0&id=1e7f06fd&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7f06fd"]])

export default __exports__